<template>
  <Page class="intro">
    <container class="intro__container">
      <div class="intro__inner">
        <Header class="intro__header" size="md"></Header>
        <h1 class="title intro__title" v-html="`Насколько вы&nbsp;разбираетесь в&nbsp;современных технологиях связи?`">
        </h1>
        <p class="text intro__text" v-html="`
            Все говорят о&nbsp;новых форматах связи, которые открывают головокружительные возможности для бизнеса.
            Новые поколения Wi&#8209;Fi, частные LTE&#8209;сети, 5G&nbsp;&mdash; все это на&nbsp;слуху, но&nbsp;сможете&nbsp;ли вы&nbsp;определить преимущества и&nbsp;недостатки каждой технологии и&nbsp;сделать правильный выбор, решающий задачи вашего бизнеса? Проверьте себя в&nbsp;нашем тесте.
        `">
        </p>
        <Button @click="go" view="primary" class="intro__button">
          Пройти тест!
        </Button>
        <div class="intro__footer">
          <Likes class="intro__likes" />
          <DevCredit class="intro__dev"></DevCredit>
        </div>
      </div>
    </container>
  </Page>
</template>

<script>
  import Header from '@/components/Header.vue'
  import Likes from '@/components/Likes.vue'
  import questions from '@/components/Quiz/questions'
  import DevCredit from '@/components/DevCreit.vue'

  export default {
    components: {
      Likes,
      Header,
      DevCredit
    },
    computed: {
      busy () {
        return this.$store.state.busy
      }
    },
    methods: {
      go () {
        if (this.busy) return
        this.$store.dispatch('init', questions)
        this.$metrics.pushEvent(this.$metrics.events.CLICK_START_QUIZ)
      }
    }
  }
</script>

<style lang="scss">
  .intro {
  }

  .intro .header__special-label {
    transition: 0.7s opacity 0.5s, 0.7s transform 0.5s;
  }

  .intro__container {
    @include less(tablet) {
      max-width: $container-mobile;
      margin-left: auto;
      margin-right: auto;
    }
  }

  .intro__inner {
    transition: 1s opacity, 1s transform;
    display: flex;
    flex-direction: column;
    min-height: 100vh;
    max-width: 480px;

    & > * {
      flex: 0 0 auto
    }

    @include more(scale) {
      padding-top: 20px;
    }
    @include mq(scale) {
      max-width: 37vw;
    }
    @include less(tablet) {
      padding-top: 100px;
    }
    @include mq(tablet) {
      @media screen and (orientation: landscape) {
        padding-top: 130px;
      }
      @media screen and (orientation: portrait) {
        padding-top: 200px;
      }
    }
  }

  .intro__header {
    transition: 0.5s opacity, 0.5s transform;
    @include more(scale) {
      margin-top: auto;
      margin-bottom: 20px;
    }
    @include less(tablet) {
      display: none;
      margin-top: 15px;
      margin-bottom: 60px;
    }
    @include mq(xmobile) {
      margin-bottom: 20px;
    }
  }

  .intro__title {
    transition: 0.5s opacity, 0.5s transform;
  }

  .intro__text {
    transition: 0.5s opacity, 0.5s transform;
  }

  .intro__button {
    width: 200px;
    transition: 0.75s opacity, 0.75s transform;

    @include more(scale) {
      margin-top: 40px;
      margin-bottom: 40px;
    }
    @include less(tablet) {
      width: 150px;
      margin-top: 20px;
    }
    @include screen-height(low) {
      margin-top: 20px;
    }
    @include mq(xmobile) {
      margin-top: 0;
    }
  }

  .intro__footer {
    margin-top: auto;
    overflow: hidden;
    display: flex;
    align-items: center;
    transition: 0.7s opacity 0.7s;

    @include more(scale) {
      padding-bottom: 60px;
    }
    @include mq(scale) {
      padding-bottom: 15rem;
    }
    @include less(tablet) {
      margin-top: 0;
      padding-top: 20px;
    }
  }

  .intro__dev {
    @include more(scale) {
      margin-left: 40px;
      * {
        font-size: 14px;
      }
    }
    @include mq(scale) {
      margin-left: 10rem;
      * {
        font-size: 3.5rem;
      }
    }
    @include less(scale) {
      * {
        font-weight: normal;
        font-size: 12px !important;
      }
    }
  }

  .intro__likes {
    @include less(tablet) {
      display: none;
    }
  }

  @include more(scale) {
    .quiz-enter-active {
      .intro__inner {
        opacity: 0;
        transform: translateX(-50px)
      }
      .intro .header__special-label {
        opacity: 0;
        transform: translateY(20px)
      }
      .intro__button {
        opacity: 0;
        transform: translateY(25%);
        transition-delay: 3s;
      }
      .intro__footer {
        opacity: 0;
      }
    }
    .quiz-enter-to {
      .intro__inner {
        opacity: 1;
        transform: translateX(0)
      }
      .intro .header__special-label {
        opacity: 1;
        transform: translateY(0);
        transition-delay: 0.55s;
      }
      .intro__button {
        opacity: 1;
        transform: translateY(10px);
      }
      .intro__footer {
        opacity: 1;
        transition-delay: 1s;
      }
    }
    .quiz-leave-active {
      .intro__inner {
        opacity: 0;
        transform: translateX(-50px);
        transition-delay: 0.35s;
      }
      .intro .header__special-label {
        opacity: 0;
        transform: translateY(-20px);
        transition-delay: 0.15s;
      }
      .intro__button {
        opacity: 0;
        transform: scale(0.85, 0.85);
        transition-delay: 0s, 0s;
      }
      .intro__footer {
        opacity: 0;
      }
    }
  }

  @include less(tablet) {
    .quiz-enter-active {
      .intro__header {
        opacity: 0;
        transform: translateY(-100%)
      }
      .intro__title {
        opacity: 0;
        transform: translateY(20px)
      }
      .intro__text {
        opacity: 0;
        transform: translateY(20px)
      }
      .intro__button {
        opacity: 0;
        transform: translateX(50%)
      }
      .intro__footer {
        opacity: 0;
      }
    }
    .quiz-enter-to {
      .intro__header {
        opacity: 1;
        transform: translateY(0)
      }
      .intro__title {
        opacity: 1;
        transform: translateY(0);
        transition-delay: 0.1s;
      }
      .intro__text {
        opacity: 1;
        transform: translateY(0);
        transition-delay: 0.2s;
      }
      .intro__button {
        opacity: 1;
        transform: translateX(0);
        transition-delay: 0.7s;
      }
      .intro__footer {
        opacity: 1;
      }
    }
    .quiz-leave {
      .intro__footer {
        opacity: 1;
        transition-delay: 0s;
      }
    }
    .quiz-leave-active {
      .intro__header {
        opacity: 0;
        transform: translateY(-100%);
        transition-delay: 0.7s;
      }
      .intro__title {
        opacity: 0;
        transform: translateY(-20px);
        transition-delay: 0.2s;
      }
      .intro__text {
        opacity: 0;
        transform: translateY(-20px);
        transition-delay: 0.1s;
      }
      .intro__button {
        opacity: 0;
        transform: scale(0.85, 0.85);
        transition-delay: 0s, 0s;
      }
      .intro__footer {
        opacity: 0;
        transition-delay: 0s;
      }
    }
  }
</style>
